import Text from 'components/Text/Text';
import React from 'react';
import DropdownMenu from './components/DropdownMenu';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import style from './SortBy.module.scss';

const SortBy: React.FC = () => {
	return (
		<Dropdown className={style.container} overlay={<DropdownMenu />} trigger={['click']} placement="bottomRight">
			<a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
				<Text translationNameSpace="form" translationKey="sortByLabel" theme="neutralLight" size="s" />
				<DownOutlined className={style.iconDropdown} />
			</a>
		</Dropdown>
	);
};

export default SortBy;
